const MESSAGE = "maximale waarde mag niet lager zijn dan de minimale";

export default (value: string, row: any) => {
    return value && (parseInt(value) > row.question.minValue) ? undefined : MESSAGE 
}
